export const CHANGED_PASSWORD = 'Changed password';
export const CREATED_GAMERTAG = 'Created gamertag';
export const DISABLED_ACCOUNT_LOGIN_PREVENTED = 'Disabled account, login prevented';
export const IS_LOGGING = true;
export const LOGGED_IN = 'Logged in';
export const LOGGED_OUT = 'Logged out';
export const REGISTERED = 'Registered';
export const UNABLE_TO_ACCESS_USER_DATA = 'Unable to access user data, login prevented';
export const UPDATED_PROFILE = 'Updated profile';
export const VIEWED_PROFILE = 'Viewed profile';
export const VIEWED_WELCOME_SCREEN = 'Viewed welcome screen';
